import React from 'react';
import { PageLayout } from '@/shared/layout';
import { UsersKpiDashboard } from './components/UsersKpiDashboard';
import { UsersModulesGrid } from './components/UsersModulesGrid';
import { RecentUserActivities } from './components/RecentUserActivities';
import { UsersAIAssistant } from './components/UsersAIAssistant';

export function UsersPage() {
  return (
    <PageLayout
      title="Nhân sự & Phân quyền"
      description="Trung tâm quản lý hồ sơ nhân viên, chấm công, tiền lương và phân quyền hệ thống"
    >
      <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">

        {/* Top KPIs Dashboard */}
        <UsersKpiDashboard />

        {/* Navigation Hub */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-blue-500 rounded-full" />
                Hệ sinh thái Nhân sự
              </h3>
            </div>
            <div className="flex-1">
              <UsersModulesGrid />
            </div>
          </div>

          <div className="lg:col-span-4 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-amber-500 rounded-full" />
                Hoạt động gần đây
              </h3>
              <button className="text-xs font-medium text-blue-600 hover:text-blue-700 hover:underline transition-colors">
                Xem toàn bộ &rarr;
              </button>
            </div>
            <div className="flex-[2] flex flex-col min-h-0">
              <RecentUserActivities />
            </div>

          </div>
        </div>
      </div>
    </PageLayout>
  );
}

export default UsersPage;
